import React, { useState } from 'react';
import { t } from '@lingui/macro';

import AlertInfoButton from '@rover/components/src/PriceLedger/components/AlertInfoButton';
import { Button, Flex, Text } from '@rover/kibble/core';
import HTMLText from '@rover/kibble/patterns/HTMLText';

import ResponsiveOverlay from '../../ResponsiveOverlay/ResponsiveOverlay';
import {
  HighlightBackgroundColorsAdapter,
  HighlightIconsAdapter,
  HiglightColorsAdapter,
} from '../constants';

import Badge from './Badge';

type HighlightProps = {
  title: string;
  color: string;
  backgroundColor: string;
  iconName: string;
  descriptionTitle?: string;
  description?: string;
};

export const Highlight: React.FC<HighlightProps> = ({
  title,
  color,
  backgroundColor,
  iconName,
  descriptionTitle,
  description,
}) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const icon = HighlightIconsAdapter[iconName];
  const iconColor = HiglightColorsAdapter[color];
  const iconBackgroundColor = HighlightBackgroundColorsAdapter[backgroundColor];

  const handleInfoIconClick = (event?: React.MouseEvent<HTMLButtonElement>): void => {
    event?.stopPropagation();
    setIsOverlayOpen(true);
  };

  const onRequestClose = (): void => setIsOverlayOpen(false);

  return (
    <Flex flexDirection="row" alignItems="center">
      <ResponsiveOverlay
        isOpen={isOverlayOpen}
        onRequestClose={onRequestClose}
        title={descriptionTitle || title}
      >
        <Flex flexDirection="column" gap="4x">
          {description && <HTMLText text={description} />}
          <Button fullWidth onPress={onRequestClose}>
            {t`Close`}
          </Button>
        </Flex>
      </ResponsiveOverlay>
      {icon && <Badge iconColor={iconColor} backgroundColor={iconBackgroundColor} icon={icon} />}
      <Text ml="2x" size="200" fontWeight="semibold">
        {title}
      </Text>
      {description && (
        <Flex ml="2x">
          <AlertInfoButton icon="info" onClick={handleInfoIconClick} />
        </Flex>
      )}
    </Flex>
  );
};
export default Highlight;
